import { CALL_INTAKE_V2_API } from 'middleware/intakeV2Api';

import {
  GET_PENDING_AUTH_IMPORT_CLIENT_CUSTOM_FIELDS_FAILURE,
  GET_PENDING_AUTH_IMPORT_CLIENT_CUSTOM_FIELDS_REQUEST,
  GET_PENDING_AUTH_IMPORT_CLIENT_CUSTOM_FIELDS_SUCCESS,
  GET_PENDING_AUTH_IMPORT_TEMPLATES_FAILURE,
  GET_PENDING_AUTH_IMPORT_TEMPLATES_REQUEST,
  GET_PENDING_AUTH_IMPORT_TEMPLATES_SUCCESS,
  GET_PENDING_AUTH_IMPORT_TEMPLATE_FAILURE,
  GET_PENDING_AUTH_IMPORT_TEMPLATE_REQUEST,
  GET_PENDING_AUTH_IMPORT_TEMPLATE_SUCCESS,
  POST_PENDING_AUTH_IMPORT_TEMPLATE_DRYRUN_FAILURE,
  POST_PENDING_AUTH_IMPORT_TEMPLATE_DRYRUN_REQUEST,
  POST_PENDING_AUTH_IMPORT_TEMPLATE_DRYRUN_SUCCESS,
  POST_PENDING_AUTH_IMPORT_TEMPLATE_FAILURE,
  POST_PENDING_AUTH_IMPORT_TEMPLATE_REQUEST,
  POST_PENDING_AUTH_IMPORT_TEMPLATE_SUBMIT_FAILURE,
  POST_PENDING_AUTH_IMPORT_TEMPLATE_SUBMIT_REQUEST,
  POST_PENDING_AUTH_IMPORT_TEMPLATE_SUBMIT_SUCCESS,
  POST_PENDING_AUTH_IMPORT_TEMPLATE_SUCCESS,
  PUT_PENDING_AUTH_IMPORT_TEMPLATE_FAILURE,
  PUT_PENDING_AUTH_IMPORT_TEMPLATE_REQUEST,
  PUT_PENDING_AUTH_IMPORT_TEMPLATE_SUCCESS,
} from './importAuthFiles.types';

export const getPendingAuthImportTemplates = () => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_PENDING_AUTH_IMPORT_TEMPLATES_REQUEST, GET_PENDING_AUTH_IMPORT_TEMPLATES_SUCCESS, GET_PENDING_AUTH_IMPORT_TEMPLATES_FAILURE],
    authenticated: true,
    endpoint: 'api/ImportTool/PendingAuths',
    method: 'GET',
  },
});

export const getPendingAuthImportTemplate = templateId => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_PENDING_AUTH_IMPORT_TEMPLATE_REQUEST, GET_PENDING_AUTH_IMPORT_TEMPLATE_SUCCESS, GET_PENDING_AUTH_IMPORT_TEMPLATE_FAILURE],
    authenticated: true,
    endpoint: `api/ImportTool/PendingAuths/${templateId}`,
    method: 'GET',
  },
});

// Kept out of the clients reducer, which caches custom fields under the client currently open in client details
export const getPendingAuthImportClientCustomFields = clientRecordId => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_PENDING_AUTH_IMPORT_CLIENT_CUSTOM_FIELDS_REQUEST, GET_PENDING_AUTH_IMPORT_CLIENT_CUSTOM_FIELDS_SUCCESS, GET_PENDING_AUTH_IMPORT_CLIENT_CUSTOM_FIELDS_FAILURE],
    authenticated: true,
    endpoint: `api/Client/customFields/${clientRecordId}`,
    method: 'GET',
  },
});

export const postPendingAuthImportTemplate = template => ({
  [CALL_INTAKE_V2_API]: {
    types: [POST_PENDING_AUTH_IMPORT_TEMPLATE_REQUEST, POST_PENDING_AUTH_IMPORT_TEMPLATE_SUCCESS, POST_PENDING_AUTH_IMPORT_TEMPLATE_FAILURE],
    authenticated: true,
    endpoint: 'api/ImportTool/PendingAuths',
    method: 'POST',
    payload: template,
  },
});

export const putPendingAuthImportTemplate = (templateId, template) => ({
  [CALL_INTAKE_V2_API]: {
    types: [PUT_PENDING_AUTH_IMPORT_TEMPLATE_REQUEST, PUT_PENDING_AUTH_IMPORT_TEMPLATE_SUCCESS, PUT_PENDING_AUTH_IMPORT_TEMPLATE_FAILURE],
    authenticated: true,
    endpoint: `api/ImportTool/PendingAuths/${templateId}`,
    method: 'PUT',
    payload: template,
  },
});

export const uploadPendingAuthImportTemplateFile = (templateId, file) => {
  const payload = new FormData();
  payload.append('file', file, file.name);

  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_PENDING_AUTH_IMPORT_TEMPLATE_DRYRUN_REQUEST, POST_PENDING_AUTH_IMPORT_TEMPLATE_DRYRUN_SUCCESS, POST_PENDING_AUTH_IMPORT_TEMPLATE_DRYRUN_FAILURE],
      authenticated: true,
      endpoint: `api/ImportTool/PendingAuths/${templateId}/DryRun`,
      method: 'POST',
      payload,
    },
  };
};

export const submitPendingAuthImportTemplateFile = (templateId, file) => {
  const payload = new FormData();
  payload.append('file', file, file.name);

  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_PENDING_AUTH_IMPORT_TEMPLATE_SUBMIT_REQUEST, POST_PENDING_AUTH_IMPORT_TEMPLATE_SUBMIT_SUCCESS, POST_PENDING_AUTH_IMPORT_TEMPLATE_SUBMIT_FAILURE],
      authenticated: true,
      endpoint: `api/ImportTool/PendingAuths/${templateId}/Submit`,
      method: 'POST',
      payload,
    },
  };
};
